import React from 'react'
import { EditingItemProps, useClearEditingItem } from 'utils/commonHooks'
import { LogTemplateProps, useInitLog } from 'utils/log'

import ActionArea, { ActionAreaProps } from './ActionArea'
import ContentArea, { ContentAreaProps } from './ContentArea'
import ContentHeaderArea, { ContentHeaderAreaProps } from './ContentHeaderArea'
import FooterArea from './FooterArea'
import GlobalFooterArea from './GlobalFooterArea'
import GlobalHeaderArea from './GlobalHeaderArea'
import HeaderArea, { HeaderAreaProps } from './HeaderArea'
import NoteArea, { NoteAreaProps } from './NoteArea'

/**
 * 要請情報を入力する画面用テンプレート
 */
const RequestTemplate: React.FC<RequestTemplateProps> = (props) => {
  useInitLog(props.title)
  useClearEditingItem(props.notClearEditingItem)

  return (
    <React.Fragment>
      <GlobalHeaderArea />
      <HeaderArea
        title={props.title}
        showContact={props.showContact}
        showBack={props.showBack}
        backAction={props.backAction}
        backTo={props.backTo}
      />
      <ContentHeaderArea
        progress={props.progress}
        description={props.description}
      />
      <ContentArea content={props.content} />
      <NoteArea warning={props.warning} error={props.error} />
      <ActionArea
        forwardLabel={props.forwardLabel}
        forwardAction={props.forwardAction}
        forwardTo={props.forwardTo}
        isDisabled={props.isDisabled}
        disabledLabel={props.disabledLabel}
        forwardLabel2={props.forwardLabel2}
        forwardAction2={props.forwardAction2}
        forwardTo2={props.forwardTo2}
        isDisabled2={props.isDisabled2}
        disabledLabel2={props.disabledLabel2}
        hideForward={props.hideForward}
        showBack={props.showBack}
        backLabel={props.backLabel}
        backAction={props.backAction}
        backTo={props.backTo}
      />
      <FooterArea />
      <GlobalFooterArea />
    </React.Fragment>
  )
}

export type RequestTemplateProps = LogTemplateProps &
  HeaderAreaProps &
  ContentHeaderAreaProps &
  ContentAreaProps &
  NoteAreaProps &
  ActionAreaProps &
  EditingItemProps

export default RequestTemplate
